// import apiFetch from 'utils/apiFetch';
import { sessionService } from 'redux-react-session';
import apiFetch from 'utils/apiFetch';
import {
  loadingAction,
} from '../../../store/globalState/global';

import {
  FETCH_PROFILE_INIT, FETCH_PROFILE_SUCCESS, FETCH_PROFILE_FAILURE,
  DELETE_ACCOUNT_INIT, DELETE_ACCOUNT_SUCCESS, DELETE_ACCOUNT_FAILURE,
} from './types';


export const deleteAccount = password => (dispatch) => {
  dispatch(loadingAction(true));
  dispatch({ type: DELETE_ACCOUNT_INIT });

  const params = { password };
  apiFetch('delete', { endPoint: 'users' }, params)
    .then((response) => {
      if (response.success) {
        dispatch({ type: DELETE_ACCOUNT_SUCCESS });
      } else {
        dispatch({ type: DELETE_ACCOUNT_FAILURE, payload: response.info });
      }
      dispatch(loadingAction(false));
    })
    .catch(() => {
      dispatch({ type: DELETE_ACCOUNT_FAILURE, payload: 'Error connecting server' });
      dispatch(loadingAction(false));
    });
};

export function fetchProfileInit() {
  return {
    type: FETCH_PROFILE_INIT,
  };
}

export function fetchProfileSuccess(success) {
  return {
    type: FETCH_PROFILE_SUCCESS,
    payload: success,
  };
}

export function fetchProfileFailure(error) {
  return {
    type: FETCH_PROFILE_FAILURE,
    payload: error,
  };
}

export function getDataAction(callback) {
  return () => {
    sessionService.loadUser().then((data) => {
      callback(data);
    });
  };
}

export function fetchProfileAction(event, {
  firstName, lastName, email, lang, image,
}, callback) {
  event.preventDefault();

  // const ProfileForm = {
  //   code: '',
  //   name: firstName,
  //   lastName,
  //   lang,
  //   status: 'active',
  //   emailList: [email],
  // };

  return (dispatch) => {
    dispatch(loadingAction(true));
    dispatch(fetchProfileInit());
    return new Promise((resolve) => {
      sessionService.saveSession({ token: '123456789' })
        .then(() => {
          sessionService.saveUser({
            email,
            firstName,
            lastName,
            lang,
            image,
          })
            .then(() => {
              dispatch(fetchProfileSuccess('Success'));
              dispatch(loadingAction(false));
              callback();
              resolve(true);
            });
        });
    });
  };


  
}

export const updateProfile = (params, hideLoading) => (dispatch, getState) => {
  if (!hideLoading) {
    dispatch(loadingAction(true));
  }

  return apiFetch('PUT', { endPoint: 'users' }, params)
    .then((response) => {
      sessionService.saveSession({ token: response.user_code })
        .then(() => {
          const user = Object.assign({}, response);
          user.instance = getState().app.id;
          sessionService.saveUser(user)
            .then(() => {
              dispatch(loadingAction(false));
            });
        });
    })
    .catch(() => {
      dispatch(loadingAction(false));
    });
};



export function getUserData(user) {
  return apiFetch('GET', { endPoint: 'user' }, { user });
}

export function getConnections(user) {
  return apiFetch(
    'GET',
    { endPoint: 'users/connection' },
    { user },
  );
}

export function getUserActions(type = '', user = 0) {
  return apiFetch(
    'GET',
    { endPoint: 'users/actions' },
    { type, user },
  );
}

export function getPrivacyElements(user) {
  return apiFetch(
    'GET',
    { endPoint: 'users/privacy/elements' },
    { user },
  );
}

export function getUserAnswers(userId) {
  return apiFetch(
    'GET',
    { endPoint: `users/${userId}/answers` },
  );
}

export function getProfileFields() {
  return apiFetch(
    'GET',
    { endPoint: 'instances/profile-fields' },
  );
}

export function getUserSettings() {
  return apiFetch(
    'GET',
    { endPoint: 'users/settings' },
  );
}

export function saveUserSettings(params) {
  return apiFetch(
    'POST',
    { endPoint: 'users/settings' },
    params,
  );
}



// WEBPACK FOOTER //
// ./src/routes/Profile/modules/actions.js